import { useCallback, useContext } from "react";
import { useProjects } from "../services/api/KeynomeAPIHooks";
import { useNavigate } from 'react-router-dom';
import { datadogRum } from '@datadog/browser-rum';
import { useOutletContext } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";

import { useMoveDatasetToProject } from "../services/api/KeynomeAPIMutations";
import { ProjectDispatchContext } from "../context/ProjectContext";

function ArchiveDatasetDialog(props) {
    const {
        activeProject,
        activeRun,
        archiveDialogOpen,
        setArchiveDialogOpen,
        setReloadRuns,
        handleClose,
    } = props;
    const { removeRecentlyViewedDataset } = useContext(ProjectDispatchContext);

    const navigate = useNavigate();
    const { setUserErrorMessage } = useOutletContext();

    const { data: projects } = useProjects(activeProject.attributes.organization_id);
    const archiveProject = projects?.find(project => project.attributes.name === "archive");

    const { mutate: moveDatasetToProject, isLoading: isArchiving } = useMoveDatasetToProject(); 

    const handleArchiveConfirm = useCallback(() => {
        moveDatasetToProject(
            { datasetId: activeRun.id, destProjectId: archiveProject.id },
            {
                onSuccess: () => {
                    handleClose()
                    removeRecentlyViewedDataset(activeRun);
                    setArchiveDialogOpen(false);
                    setReloadRuns()

                    const activeProjectURL = new URL(activeProject.attributes.keynome_web_url);
                    navigate(activeProjectURL);
                },
                onError: (error) => {
                    setUserErrorMessage('Failed to archive dataset. Please wait a few minutes and try again. Contact support@dayzerodiagnostics.com if you require assistance.');
                    datadogRum.addError(error);
                }
            }
        )
    }, [activeProject, activeRun, archiveProject, moveDatasetToProject, setUserErrorMessage, navigate, setReloadRuns, removeRecentlyViewedDataset, handleClose, setArchiveDialogOpen]);

    return <Dialog
        open={archiveDialogOpen}
        onClose={() => setArchiveDialogOpen(false)}
    >
        <DialogTitle>Archive Dataset</DialogTitle>
        <DialogContent>
        <DialogContentText>
            { !!archiveProject
                ? "Are you sure you want to archive this dataset? After archiving, you will no longer be able to see any samples or results associated with this dataset."
                : "Unable to archive projects in this organization. Contact support@dayzerodiagnostics.com if you require assistance."
            }
        </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={() => setArchiveDialogOpen(false)} disabled={isArchiving}>Cancel</Button>
        {
            !!archiveProject ?
            <Button 
                onClick={handleArchiveConfirm}
                color="primary"
                variant="contained"
                autoFocus
                disabled={isArchiving}
                aria-label="confirm-archive"
            >
                {isArchiving ? 'Archiving...' : 'Yes, Archive'}
            </Button>
            : <></>
    }
        </DialogActions>
    </Dialog>
}

export default ArchiveDatasetDialog;